import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import { Form, FormTextInput } from 'application/Shared/Components/Form';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { noIntegrationFormSchema } from './validator';

export const NoIntegrationForm = ({ children, onSubmit }) => {
    const { t } = useTranslation();
    return (
        <Box mt="32px" data-testid="noIntegrationForm">
            <Form
                defaultValues={{
                    domains: '',
                    name: ''
                }}
                validator={yupResolver(noIntegrationFormSchema(t))}
                onSubmit={onSubmit}
            >
                <Box mx="24px" mb="24px" sx={{ minWidth: '400px' }}>
                    <FormTextInput
                        name="name"
                        label={t('Common.client_name')}
                        placeholder={t('Common.brand_name')}
                        required
                    />
                    <FormTextInput
                        name="domains"
                        label={t('Clients.domain(s)')}
                        placeholder="saas.com,saas.onmicrosoft.com"
                        tooltipText={t('Tooltips.domains_comma_separated')}
                        required
                    />
                </Box>
                {children}
            </Form>
        </Box>
    );
};
